<template>
    <div class="suscripcion">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="6" :url="url"/>
        <div class="container">

            <h4 class="text-center mt-4">
                Mi membresía
            </h4>

            <div class="row">
                
                <!-- Lista de Tarjetas -->
                <div class="col-sm-6">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Tarjetas</h5>

                            <div class="card-subtitle mt-1" v-if="listCards.length == 0">
                                No tienes una tarjetas registradas. <br>
                                <a href="#editTarjeta" class="mt-5" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="editTarjeta" v-if="!isfree">
                                    <b>Agregar Tarjeta +</b>
                                </a>
                                <div id="editTarjeta" class="collapse mt-3" v-if="!isfree">
                                    Ingrese los datos de la tarjeta.
                                    <stripe-element-card
                                        ref="elementRef"
                                        :hidePostalCode="true"
                                        :pk="this.publishKey"
                                        @token="CreateToken"
                                    />
                                    <button class="btn orange btn-sm float-right" @click="submit">Guardar tarjeta</button>
                                </div>
                            </div>

                            <div class="mt-4 d-flex justify-content-between" v-for="list in listCards" :key="list.id">
                                <div class="d-flex flex-row align-items-center"> 
                                    <img src="https://i.imgur.com/qHX7vY1.png" class="rounded" width="70">
                                    <div class="d-flex flex-column ml-4"> 
                                        <span class="business">Número de tarjeta</span>                                         
                                        <span class="plan">**** {{list.last4}}</span> 
                                    </div>                                    
                                </div> 
                                <div class="flex-column mt-3">                                     
                                    <a class="btn btn-light btn-sm" @click="showModalAplicaBaja(list.customer, list.id)">
                                        <font-icon icon="trash-alt"/> Baja de tarjeta
                                    </a>
                                </div>                               
                            </div>             
                            
                        </div>
                    </div>
                </div>
                
                <!-- Detalles de suscripción -->
                <div class="col-sm-6">
                    <div class="card">
                        <div class="card-body">                            

                            <div>
                                <h4 class="heading">Detalle de membresía</h4>

                                <!-- Mensaje para usuarios con membresia -->
                                <p class="text" v-if="!isfree">
                                    Actualice su membresía para poder disfrutar de todas las funciones y ventajas 
                                    de nuestros planes premium lo antes posible.
                                </p>

                                <!-- Mensaje para usuarios con membresia gratuita -->
                                <div class="alert alert-warning show text-justify" role="alert" v-else>
                                    <strong>
                                        <i class="fas fa-exclamation-circle"></i>
                                        Tu membresía es gratuita
                                    </strong> 
                                    <br/>
                                    Actualice a uno de nuestros planes premium, para poder disfrutar de todas 
                                    las funciones y ventajas que estos le ofrecen.
                                </div>
                            </div>

                            <div class="pricing p-3 rounded mt-4 mb-4 d-flex justify-content-between">
                                <div class="images d-flex flex-row align-items-center">                                     
                                    <i class="fas fa-file-invoice-dollar fa-4x text-warning"></i>
                                    <div class="d-flex flex-column ml-4"> 
                                        <span class="business">                                            
                                            {{getPeriodo(suscription.items.data[0].price.recurring)}}
                                        </span> 
                                        <span class="plan" v-if="!isfree">
                                            Próxima factura <br/>                                            
                                            <span>{{ suscription.current_period_end | moment("DD MM YYYY") }}</span> 
                                        </span> 
                                    </div>
                                </div>
                                <div class="d-flex flex-row align-items-center" v-if="!isfree"> 
                                    <sup class="dollar font-weight-bold">$</sup> 
                                    <span class="amount ml-1 mr-1">
                                        <!-- Stripe maneja los costos en centavos por eso la división -->
                                        {{moneda(suscription.items.data[0].price.unit_amount_decimal / 100)}} 
                                    </span> 
                                    <sup>USD</sup>                                    
                                </div>                                                    
                            </div>

                            <router-link to="/Pagos" class="btn orange btn-sm float-right">Cambiar membresía</router-link>                            
                            <a class="btn btn-light btn-sm" v-if="!isfree" @click="showModalCancelSuscr()">
                                <i class="fas fa-times"></i>
                                Cancelar membresía
                            </a>
                        </div>                          
                    </div>
                </div>
                
                <!-- Modal confirmar baja de tarjeta -->
                <div class="modal fade" tabindex="-1" role="dialog" id="aplicarBaja" aria-hidden='true' data-backdrop='static'>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">                                
                                <h5 class="modal-title">
                                    <i class="fas fa-exclamation-triangle"></i>
                                    Baja de tarjeta
                                </h5>                                
                            </div>                        
                            <div class="modal-body">                            
                                <p class="text-justify">
                                    Al dar baja tu forma de pago ya no se factura el próximo periodo y no podrás enviar tus ofertas. 
                                    Podrás reanudar el pago de tu membresía cuando tú lo decidas.
                                </p>            
                                <p class="text-right">
                                    ¿Deseas continuar?
                                </p>
                            </div>
                            <div class="modal-footer">                              
                                <button class="btn btn-warning" :disabled="spiner" @click="DeleteCard()">                                
                                    <span class="spinner-border spinner-border-sm" 
                                        role="status" 
                                        aria-hidden="true"
                                        v-if="spiner">
                                    </span>
                                    Si, aplicar baja
                                </button>
                                <button type="button" 
                                        class="btn btn-light" 
                                        :disabled="spiner"                                         
                                        data-dismiss="modal">
                                    Cerrar
                                </button>
                            </div>
                                                    
                        </div>
                    </div>
                </div>

                <!-- Modal confirmar cancelación de suscripción -->
                <div class="modal fade" tabindex="-1" role="dialog" id="aplicarCancelSuscr" aria-hidden='true' data-backdrop='static'>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">
                                    <i class="fas fa-exclamation-triangle"></i>                                    
                                    Cancelar membresía
                                </h5>                                
                            </div>                        
                            <div class="modal-body">                                    
                                <p class="text-justify">                                    
                                    Al proceder con la cancelación perderás las ventajas de tu membresía actual, 
                                    sin embargo, puedes continuar usando tus suscripción en <span class="itsapp_font"><b>itSAPp</b></span> 
                                    de manera gratuita por el tiempo que lo desees.
                                </p>            
                                <p class="text-right">
                                    ¿Deseas cancelar la membresía?
                                </p>                     
                            </div>
                            <div class="modal-footer">                              
                                <button class="btn btn-warning" :disabled="spiner" @click="CancelSuscripcion()">
                                    <span class="spinner-border spinner-border-sm" 
                                        role="status" 
                                        aria-hidden="true"
                                        v-if="spiner">
                                    </span>
                                    Si, cancelar
                                </button>
                                <button type="button" 
                                        class="btn btn-light" 
                                        :disabled="spiner"
                                        data-dismiss="modal">
                                    Cerrar
                                </button>
                            </div>
                                                    
                        </div>
                    </div>
                </div>

            </div>

        </div>        
                
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import Menu from '@/components/Menu'
import Submenu from '@/components/Submenu'
import { StripeElementCard  } from '@vue-stripe/vue-stripe';

import $ from 'jquery';
export default {
components:{ Menu, Submenu, StripeElementCard },
mixins: [ globalFunctions ],
    data(){
        return{
            sesion: false,
            listCards: [],            
            isfree: true,            
            dataCard: {
                id_customer: null,
                id_tarjeta: null
            },
            spiner: false,
            suscription: this.reset()
        }
    },
    computed:{
        ...mapState(['url', 'urlApi', 'publishKey'])
    },
    mounted(){
        this.getCardList();        
        this._getSuscription();                
        this.sesion = this.checkUser();
    },
    methods: {
        
        submit () {
            this.$refs.elementRef.submit();
        },

        CreateToken (token) {            
            this.NewCard(token.id);
        },

        getCardList() {
            
            let data = {};
            let url = this.urlApi + '/cardlist/' + localStorage.userID;

            this.axios
                .get(url, data)
                .then(response => {
                    this.listCards = response.data;                    
                })
                .catch(e => {                    
                }
            );

        },

        _getSuscription() {

            let data = {};
            let url = this.urlApi + '/'+ localStorage.userID;

            this.axios
                .get(url, data)
                .then(response => {
                    if (response.data && response.data.status == 'active') {
                        this.suscription = response.data;
                        this.isfree = false;
                    } else {
                        this.suscription = this.reset();
                        this.isfree = true;
                    }
                })
                .catch(e => {                    
                }
            );

        },        

        CancelSuscripcion() {
            
            let data = {};
            let url = this.urlApi + '/cancel/' + localStorage.userID;

            this.spiner = true;
            this.axios
                .put(url, data)
                .then(response => {                    
                    this._getSuscription();                 
                    this.spiner = false;   
                    $("#aplicarCancelSuscr").modal('hide');
                })
                .catch(e => {                    
                }
            );

        },

        DeleteCard() {
                        
            let url = this.urlApi + '/card';
            
            this.spiner = true;
            this.axios
                .delete(url, { data : this.dataCard })
                .then(response => {                                                
                    this.getCardList();
                    this.spiner = false;
                    $("#aplicarBaja").modal('hide');
                })
                .catch(e => {                    
                }
            );
        },

        NewCard(token) {            

            let data = {token: token};
            let url = this.urlApi + "/card/" + localStorage.userID;

            this.axios
                .post(url, data )
                .then(response => {                                                       
                    this.getCardList();                    
                })
                .catch(e => {                    
                }
            );
        },
               
        showModalAplicaBaja(id_customer, id_tarjeta){                                

            this.dataCard = {
                id_customer: id_customer,
                id_card: id_tarjeta
            }

            $("#aplicarBaja").modal('show');
        },

        showModalCancelSuscr() {
            $("#aplicarCancelSuscr").modal('show');
        },

        getPeriodo(recurring) {

            var periodo = "Gratuita"
            if (recurring.interval == 'month' && recurring.interval_count == 1 ){
                periodo = "Mensual";
            } else if (recurring.interval == 'month' && recurring.interval_count == 6) {
                periodo = "Semestral";
            } else if (recurring.interval == 'year' && recurring.interval_count == 1) {
                periodo = "Anual";
            }

            return periodo;
            
        },
        
        reset() {
            return {
                current_period_end: null,
                items: {
                    data: [
                        { price:{ recurring: { interval: 'free' }, unit_amount_decimal: 0 } }
                    ]
                },
                status: null
            }
        }

    }
}
</script>

<style scoped>

.card {
    border: none;
    border-radius: 8px;
    box-shadow: 5px 6px 6px 2px #e9ecef
}

.heading {
    font-size: 23px;
    font-weight: 00
}

.text {
    font-size: 16px;
    font-weight: 500;
    color: #b1b6bd
}

.pricing {
    border: 2px solid #ffc6bc;
    background-color: #fbf8f0
}

.business {
    font-size: 20px;
    font-weight: 500
}

.plan {
    color: #aba4a4;
    font-size: 14px;    
}

.dollar {
    font-size: 16px;
    color: #6b6b6f
}

.amount {
    font-size: 30px;
    font-weight: 500
}

.year {    
    color: #6b6b6f;    
}

.detail {
    font-size: 22px;
    font-weight: 500
}

</style>


// WEBPACK FOOTER //
// src/views/Suscripcion/Suscripcion.vue